import React, { useEffect, useRef } from 'react';
import anime from 'animejs';
import animationManager from '../utils/AnimationManager';

/**
 * ScanningLine - Ambient scanning line effect across terminal
 */
const ScanningLine = () => {
  const lineRef = useRef(null);

  useEffect(() => {
    if (!lineRef.current || !animationManager.shouldAnimate()) return;
    
    // Disable on mobile for better performance
    if (window.innerWidth < 768) return;

    anime({
      targets: lineRef.current,
      translateY: ['0vh', '100vh'],
      duration: 3000,
      loop: true,
      easing: 'linear',
      opacity: [0, 0.3, 0.6, 0.3, 0]
    });
  }, []);

  return (
    <div
      ref={lineRef}
      className="fixed left-0 w-full h-0.5 pointer-events-none z-10"
      style={{
        background: 'linear-gradient(90deg, transparent, #00ff41, transparent)',
        boxShadow: '0 0 20px #00ff41'
      }}
    />
  );
};

export default ScanningLine;
